import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M13.828 9.567V2c3.878.186 7 3.464 7.172 7.567zm1.74-5.843-.467-.173v4.657h4.44l-.161-.474c-.634-1.87-2.038-3.35-3.813-4.01M5.235 10.994l-.08-.181-.093-.21H3V9.244h2.866l.935 2.072H21a8.14 8.14 0 0 1-1.576 4.495l-.191.26.234.219a3.33 3.33 0 0 1 1.048 2.44c0 1.812-1.398 3.27-3.097 3.27-1.55 0-2.848-1.207-3.062-2.8l-.041-.308H11.66l-.041.308c-.214 1.593-1.511 2.8-3.061 2.8-1.7 0-3.098-1.458-3.098-3.27 0-1.247.659-2.33 1.631-2.878l.326-.184-.2-.321c-.042-.066-.189-.37-.401-.829-.205-.445-.459-1.004-.705-1.554a404 404 0 0 1-.877-1.97m14.305 1.681H7.386l.24.511.313.679c.163.357.29.632.357.753l.005.008.523.838.156.024c1.04.158 1.93.865 2.374 1.84l.094.205h3.081l.094-.207c.498-1.105 1.57-1.865 2.795-1.865.133 0 .274.01.392.027l.203.03.41-.55a6.6 6.6 0 0 0 .957-1.82zM8.56 16.82c-1.018 0-1.825.862-1.825 1.91s.807 1.91 1.825 1.91 1.824-.861 1.824-1.91-.807-1.91-1.824-1.91m8.859 0c-1.018 0-1.824.862-1.824 1.91s.806 1.91 1.824 1.91c1.017 0 1.824-.861 1.824-1.91s-.807-1.91-1.824-1.91",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }